// Main JS file

document.addEventListener('DOMContentLoaded', init);

function init(e) {

    // Scroll delta
    var lastScrollPosition = 0;

    // Nav toggle
    (function () {
        var navToggle = document.querySelector('.nav-toggle');
        var navOpenClass = 'nav-open';

        function toggleNav(e, state) {
            var method;
            if (typeof state === 'undefined') {
                method = 'toggle';
            } else {
                method = state ? 'add' : 'remove';
            }
            document.body.classList[method](navOpenClass);
        }

        if (navToggle) {
            navToggle.addEventListener('click', toggleNav);
            document.addEventListener('keydown', function (e) {
                if (e.key === 'Escape') {
                    toggleNav(e, false);
                }
            });
            // document.addEventListener('scroll', function (e) {
            //     toggleNav(e, false);
            // });

            // Fixed/slim header
            (function (e) {
                var header = document.querySelector('.header'),
                    hiddenClass = 'header--hidden',
                    thresholdHidden = header.offsetHeight,
                    scrollDirection = 'down';

                function toggleHiddenHeader(state) {
                    header.classList.toggle(hiddenClass, state);
                }

                window.addEventListener('scroll', function (e) {
                    var scrollDelta = (window.scrollY - lastScrollPosition);
                    if (scrollDelta > 0) {
                        // Scroll down
                        scrollDirection = 'down';
                        toggleHiddenHeader(window.scrollY > thresholdHidden);
                    } else {
                        // Scroll up
                        scrollDirection = 'up';
                        toggleHiddenHeader(false);
                    }

                    lastScrollPosition = window.scrollY;
                });

                toggleHiddenHeader(false);
            })();
        }
    })();

    // Slides (https://glidejs.com/)
    (function() {
        const slides = document.querySelector('.slides');
        if (slides) {
            const glideOptions = {
                type: 'carousel',
                autoplay: 2500,
                animationDuration: 500,
                hoverpause: false,
                gap: 0
            }
            new Glide('.glide', glideOptions).mount();
        }
    })();

    // Go to top
    (function() {
        const top = document.querySelector('.top');
        if (top) {
            top.addEventListener('click', () => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                })
            });

            document.addEventListener('scroll', function (e) {
                document.body.classList.toggle('top-visible', (window.pageYOffset > top.dataset.threshold));
            });
        }
    })();

    // Collapse
    (function() {
        const collapse = document.querySelectorAll('.collapse');
        const collapseBodyClass = 'collapse__body';

        function initCollapse(collapse) {
            collapse.addEventListener('click', (e) => {
                let isBody = e.target.closest('.' + collapseBodyClass);
                if (isBody) return;
                e.preventDefault();
                toggleCollapse(collapse, collapse.open);
            });

            if (collapse.open) {
                toggleCollapse(collapse, !collapse.open);
            }
        }

        function toggleCollapse(collapse, open) {
            const body = collapse.querySelector('.' + collapseBodyClass);

            if (!open) {
                // Open
                collapse.open = true;
                body.style.maxHeight = 'none';
                const bodyCoords = body.getBoundingClientRect();
                body.style.maxHeight = '0';
                setTimeout(() => {
                    body.style.maxHeight = bodyCoords.height + 'px';
                }, 25);

                // scroll into view
                const collapseCoords = collapse.getBoundingClientRect();
                const offsetBottom = window.innerHeight - (collapseCoords.bottom + bodyCoords.height);
                const fitToPage = (collapseCoords.height + bodyCoords.height) < window.innerHeight;

                if (offsetBottom < 0 && fitToPage) {
                    window.scrollBy({
                        top: -offsetBottom,
                        behavior: 'smooth'
                    });
                }
            } else {
                // Close
                function handleTransitionEnd(e) {
                    if (e.propertyName !== 'max-height' && e.target !== body) return;
                    collapse.open = false;
                    body.removeEventListener('transitionend', handleTransitionEnd);
                }

                body.style.maxHeight = '0';
                body.addEventListener('transitionend', handleTransitionEnd);
            }
        }

        collapse.forEach(collapse => initCollapse(collapse));
    })();

    // Tabs
    (function() {
        const tabs = document.querySelectorAll('[data-tabs] .tiles__item-container');
        const tabActiveClass = 'tiles__item-container--active';
        const contents = document.querySelectorAll('[data-tab-content]');
        const hashId = location.hash.substring(1);
        const defaultId = tabContentExists(hashId) ? hashId : tabs[0].hash.substring(1);

        if (tabs) {
            initTabs(defaultId);
        }

        function initTabs(id) {
            contents.forEach(content => content.removeAttribute('id'));
            setActiveTab(id);

            function handleClick(e) {
                e.preventDefault();
                const id = e.currentTarget.hash.substring(1);
                setActiveTab(id);
            }

            tabs.forEach(tab => tab.addEventListener('click', handleClick));
        }

        function tabContentExists(id) {
            return (Array.from(contents).filter(content => content.dataset.tabContent === id).length > 0);
        }

        function setActiveTab(id) {
            if (!tabContentExists(id)) return;

            tabs.forEach(tab => tab.classList.toggle(tabActiveClass, (tab.hash.substring(1) === id)));
            contents.forEach(content => content.hidden = (content.dataset.tabContent !== id));
            history.replaceState({}, '', '#' + id);
        }
    })();

}
